import { useTranslationAccount } from 'domains/Account/hooks';
import {
  SelectProductList,
  SelectedProductInterface,
} from 'domains/Catalog/Products/components';
import { useTaxExceptionsContext } from '../../ProductsTaxExceptions';

interface SelectProductsModalProps {
  isShow: boolean;
  onClose: () => void;
  selectedProducts: SelectedProductInterface[];
  onChange: (selected: SelectedProductInterface[]) => void;
}

function SelectProductsModal({
  isShow,
  onClose,
  selectedProducts,
  onChange,
}: SelectProductsModalProps) {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions.modal');
  const { productIdWithExceptions } = useTaxExceptionsContext();

  return (
    <SelectProductList
      title={t('selectProducts')}
      onClose={onClose}
      isShow={isShow}
      selectedProducts={selectedProducts}
      onChange={onChange}
      disabledProducts={productIdWithExceptions}
    />
  );
}

export default SelectProductsModal;
